import { PaginatedResponse } from "@autfit/shared-types";

/** Page size used when a caller needs every row of a paginated endpoint. */
export const FETCH_ALL_PAGE_SIZE = 500;

/**
 * Loads every page of a paginated endpoint and returns all items.
 *
 * Use it for pickers and lists that filter on the client (test participant
 * selection, organization list). A single "large" page (for example
 * pageSize 100 or 1000) silently cuts the list off once the data grows.
 */
export async function fetchAllPages<T>(
  fetchPage: (page: number, pageSize: number) => Promise<PaginatedResponse<T>>,
  pageSize: number = FETCH_ALL_PAGE_SIZE,
): Promise<T[]> {
  const first = await fetchPage(1, pageSize);
  const items = [...first.items];
  const pages = Math.ceil(first.total / pageSize);
  for (let page = 2; page <= pages; page++) {
    const next = await fetchPage(page, pageSize);
    if (next.items.length === 0) break;
    items.push(...next.items);
  }
  return items;
}
